export const safify = (value: any) => {
  if (Number.isNaN(value)) return undefined
  return value ?? undefined
}
